import { useState } from 'react'
import { BiCaretDown, BiCaretUp, BiLoaderAlt } from 'react-icons/bi'
import { fetchJobs, fetchWebhookLogs } from '../../api'
import {
  getUserState,
  setJobsSortDirection,
  setWebhookLogsSortDirection,
  useDispatch,
  useSelector,
} from '../../store'
import { SORT_ASCENDING, SORT_DESCENDING } from '../TaskList/JobListDef'

interface SortTableHeaderProps {
  name: string
  icon: JSX.Element
  webhookId?: string
}

export const SortTableHeader = ({
  name,
  icon,
  webhookId,
}: SortTableHeaderProps) => {
  const dispatch = useDispatch()
  const { jobsSortDirection, webhookLogsSortDirection } =
    useSelector(getUserState)

  const [loading, setLoading] = useState(false)

  const onSortDirectionChange = async () => {
    setLoading(true)
    if (webhookId !== undefined) {
      dispatch(
        setWebhookLogsSortDirection(
          webhookLogsSortDirection === SORT_ASCENDING
            ? SORT_DESCENDING
            : SORT_ASCENDING
        )
      )
      await fetchWebhookLogs({ webhookId, refreshing: true })
    } else {
      dispatch(
        setJobsSortDirection(
          jobsSortDirection === SORT_ASCENDING
            ? SORT_DESCENDING
            : SORT_ASCENDING
        )
      )
      await fetchJobs({ refreshing: true })
    }
    setLoading(false)
  }

  return (
    <th>
      <div className={'SortTableHeader'}>
        <button
          type="button"
          className={loading ? 'cursor-wait' : ''}
          onClick={() => !loading && onSortDirectionChange()}
        >
          {icon}
          {name}
        </button>
        <button
          type="button"
          className={loading ? 'cursor-wait' : ''}
          onClick={() => !loading && onSortDirectionChange()}
        >
          {loading ? (
            <BiLoaderAlt className="loadingIcon" />
          ) : (webhookId !== undefined
              ? webhookLogsSortDirection
              : jobsSortDirection) === SORT_ASCENDING ? (
            <BiCaretUp />
          ) : (
            <BiCaretDown />
          )}
        </button>
      </div>
    </th>
  )
}

SortTableHeader.defaultProps = {
  icon: null,
}
